var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { LocalStorage } from './storage';
var WebpTypeList = ['lossy', 'lossless', 'alpha', 'animation'];
var CACHE_OUT_DATED_TIME = 15 * 24 * 60 * 60 * 1000; // 15天
var WebPManager = /** @class */ (function () {
    function WebPManager() {
    }
    WebPManager.prototype.checkWebp = function (feature) {
        return __awaiter(this, void 0, void 0, function () {
            var webpImages, img;
            return __generator(this, function (_a) {
                webpImages = {
                    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
                    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
                    alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
                    animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
                };
                img = new Image();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        img.onload = function () {
                            var result = img.width > 0 && img.height > 0;
                            resolve(result);
                        };
                        img.onerror = function () {
                            var result = false;
                            reject(result);
                        };
                        img.src = "data:image/webp;base64, " + webpImages[feature];
                    })];
            });
        });
    };
    WebPManager.prototype.setIsSupportWebPCache = function (data) {
        var now = new Date().getTime();
        var dataWithCreatedAt = __assign(__assign({}, data), { createdAt: now });
        var supportWebPCacheLocalStorage = new LocalStorage('supportWebPCache');
        supportWebPCacheLocalStorage.setItem('WebPSupportList', JSON.stringify(dataWithCreatedAt));
    };
    /**
     * return { isAllSupported: boolean; [key: keyof WebpTypeList]: boolean; createdAt: number }
     */
    WebPManager.prototype.getIsSupportWebP = function () {
        var supportWebPCacheLocalStorage = new LocalStorage('supportWebPCache');
        var cache = JSON.parse(supportWebPCacheLocalStorage.getItem('WebPSupportList') || '{}');
        return cache;
    };
    WebPManager.prototype.checkIsCacheOutDated = function (createdAt) {
        if (!createdAt) {
            return true;
        }
        var now = new Date().getTime();
        if (now - createdAt > CACHE_OUT_DATED_TIME) {
            return true;
        }
        return false;
    };
    WebPManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cache, isCacheSet, isCacheOutDated, data, isAllSupported, WebpTypeList_1, WebpTypeList_1_1, WebpType, result, e_1, e_2_1;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cache = this.getIsSupportWebP();
                        isCacheSet = Object.keys(cache).length > 0;
                        isCacheOutDated = this.checkIsCacheOutDated(cache.createdAt);
                        data = {};
                        isAllSupported = true;
                        if (!(!isCacheSet || isCacheOutDated)) return [3 /*break*/, 11];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        WebpTypeList_1 = __values(WebpTypeList), WebpTypeList_1_1 = WebpTypeList_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!WebpTypeList_1_1.done) return [3 /*break*/, 7];
                        WebpType = WebpTypeList_1_1.value;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.checkWebp(WebpType)];
                    case 4:
                        result = _b.sent();
                        data[WebpType] = result;
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        data[WebpType] = false;
                        isAllSupported = false;
                        return [3 /*break*/, 6];
                    case 6:
                        WebpTypeList_1_1 = WebpTypeList_1.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (WebpTypeList_1_1 && !WebpTypeList_1_1.done && (_a = WebpTypeList_1.return)) _a.call(WebpTypeList_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        data.isAllSupported = isAllSupported;
                        this.setIsSupportWebPCache(data);
                        _b.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return WebPManager;
}());
export var webPManager = new WebPManager();
//# sourceMappingURL=webP.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/webP.js
// module id = 1229
// module chunks = 0